export default __webpack_public_path__ + "static/media/Email- Emails.bb9c0c2b.png";